export const generateComposerUrl = (accountId: string, isProd: boolean) => {
  return isProd
    ? `/website/as/${accountId}/${accountId}-admin`
    : `/website/as/${accountId}/${accountId}-admin`;
};
export const genrateControlCenterUrl = (accountId: string, isProd: boolean) => {
  return isProd
    ? `/welcome/as/${accountId}/${accountId}-admin/`
    : `/welcome/as/${accountId}/${accountId}-admin/`;
};
export const generateDnaUrl = (accountId: string) => {
  return `https://dna.dealer.com/views/clients/client-dashboard/client-dashboard?accountId=${accountId}`;
};
export const generateDashboardUrl = (
  accountId: string,
  sameWindow?: boolean
) => {
  return sameWindow ? `/dealer/${accountId}` : `/landing/dealer/${accountId}/`;
};

export const generateLinks = (
  accountId: string,
  isProd: boolean,
  sameWindow?: boolean
) => {
  return [
    {
      label: "Dashboard",
      sameWindow,
      url: generateDashboardUrl(accountId, sameWindow)
    },
    {
      label: "ControlCenter",
      sameWindow: false,
      url: genrateControlCenterUrl(accountId, isProd)
    },
    {
      label: "Composer",
      sameWindow: false,
      url: generateComposerUrl(accountId, isProd)
    },
    {
      label: "DNA",
      sameWindow: false,
      url: generateDnaUrl(accountId)
    }
  ];
};
